module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"videoNotPlayable":"Dieses Video kann im Moment nicht auf Deinem Gerät abgespielt werden.","videoConverting":"Das Video wird gerade noch vorbereitet und steht dir bald zur Verfügung."},"en":{"videoNotPlayable":"This video is currently not playable on your device.","videoConverting":"This video is currently converting."}}')
  delete Component.options._Ctor
}
